import Highway from '@dogstudio/highway';

import Header from './_modules/header';
import Active from './_modules/active';

// Renderers
import Default from './_renderers/default';
import Agence from './_renderers/agence';
import Actualites from './_renderers/actualites';
import ProjectGrid from './_renderers/projectgrid';
import Home from './_renderers/home';
import Post from './_renderers/post';

// Transitions
import Fade from './_transitions/fade';

(() => {
  Header.init('/' + document.querySelector('.js-post').dataset.routerView);
  Active.init('/' + document.querySelector('.js-post').dataset.routerView);
  const H = new Highway.Core({
    renderers: {
      'default': Default,
      'agence': Agence,
      'actualites': Actualites,
      'projectgrid': ProjectGrid,
      'home': Home,
      'post': Post
    },
    transitions: {
      default: Fade,
    }
  });

  H.on('NAVIGATE_IN', ({ to, trigger, location }) => {
    document.body.classList = to.page.body.classList;
    var pgurl = location.href.substr(location.href.lastIndexOf("/"));
    if (pgurl != '/' && pgurl != '/home') Header.init(pgurl);
    Active.init(pgurl);
  });

  H.on('NAVIGATE_OUT', ({ from, trigger, location }) => {
    var pgurl = location.href.substr(location.href.lastIndexOf("/"));
    if (pgurl === '/' || pgurl === '/home') Header.init(pgurl);
    document.querySelectorAll('video').forEach(video => {
      video.src = '';
    })
  });

})();